import { ensureDefined } from '@avantia/client-and-server-utilities';
import { createAddressSummaryWidget } from '../../../engineClient/components/formControls/standard';
import { HpInputControlProps } from '../../../engineClient/types';
import { questionIds } from '../../../types/questionConstants';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';

interface InsuredAddressCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
}

export function InsuredAddressCustomControl(props: InsuredAddressCustomControlProps): JSX.Element {
  const { answers, pageProps, questionText } = props;
  const { policies } = pageProps;
  ensureDefined(policies, 'policies');
  const policyReference = answers[questionIds.policyInstance].customer as string;
  const selectedPolicy = policies[policyReference];
  const { house, street, locality, county, postcode } = selectedPolicy;

  const addressSummary = createAddressSummaryWidget({
    propertyNameNumber: house,
    addressLine1: street,
    townCity: locality,
    county,
    postcode
  });

  return (
    <div className="av-card av-card-child hp-address-view av-text-semi-large">
      <span>
        <strong>{questionText}</strong>
      </span>
      {addressSummary}
    </div>
  );
}
